/// <amd-module name="Artifacts/Maven/commands/Promote" />
import { MavenActions } from "Artifacts/Maven/redux";
import { getPromoteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createPromoteCommand = getPromoteCommandCreator(MavenActions.promote);
